jQuery(document).ready(function ($) {

    if( $("h2").length ) {

        $( "h2" ).each(function( index ) {

            var cible = $(this)

            var split = new SplitText(cible, {
                type: "lines",
                tag:'span',
                linesClass: 'contentLine++'
            });

            gsap.from(split.lines, {
                duration: 1,
                x:45,
                opacity: 0,
                stagger: 0.10,
                scrollTrigger: {
                    trigger: cible,
                    markers: false,
                    start: "bottom 85%"
                }

            });

        })


    }

})